"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceQueryParameters = exports.extractQueryParameters = void 0;
const splitQuery_1 = require("./splitQuery");
function createParameterizerContext(sql, options) {
    return {
        options,
        source: sql,
        position: 0,
        currentDelimiter: (0, splitQuery_1.getInitialDelimiter)(options),
        end: sql.length,
        wasDataOnLine: false,
        isCopyFromStdin: false,
        isCopyFromStdinCandidate: false,
        beginEndIdentLevel: 0,
    };
}
function extractQueryParameters(sql, options) {
    if (!sql || !options) {
        return [];
    }
    const context = createParameterizerContext(sql, options);
    const res = new Set();
    while (context.position < context.end) {
        const token = (0, splitQuery_1.scanToken)(context);
        if (token === null) {
            break;
        }
        if (token.type === 'parameter') {
            if (token.value == '?') {
                res.add(`?${res.size + 1}`);
            }
            else {
                res.add(token.value);
            }
        }
        context.position += token.length;
    }
    return Array.from(res);
}
exports.extractQueryParameters = extractQueryParameters;
function replaceQueryParameters(sql, params, options) {
    if (!sql || !options) {
        return sql;
    }
    const context = createParameterizerContext(sql, options);
    let res = '';
    let questionParamCounter = 0;
    while (context.position < context.end) {
        const token = (0, splitQuery_1.scanToken)(context);
        if (token === null) {
            break;
        }
        if (token.type === 'parameter') {
            const paramName = token.value == '?' ? `?${++questionParamCounter}` : token.value;
            if (params[paramName]) {
                res += params[paramName];
            }
            else {
                res += sql.substring(context.position, context.position + token.length);
            }
        }
        else {
            res += sql.substring(context.position, context.position + token.length);
        }
        context.position += token.length;
    }
    return res;
}
exports.replaceQueryParameters = replaceQueryParameters;
